import { SvgIcon, SvgIconProps } from "@mui/material";

export const StrikethroughIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m13.799 13 .316.122a3.556 3.556 0 0 1 2.274 3.316v.006A3.556 3.556 0 0 1 12.833 20h-2.667a3.556 3.556 0 0 1-3.556-3.556M4 13h16M7.509 10.063c-.556-.652-.898-1.477-.898-2.372A3.692 3.692 0 0 1 10.302 4h2.531a3.556 3.556 0 0 1 3.556 3.555"
      />
    </svg>
  </SvgIcon>
);
